import {Button, Menu, MenuItem} from "@mui/material";
import {Box} from "@mui/system";
import {useState} from "react";
import {RoutesGrid} from "../../../components/Routes/RoutesGrid";
import {ClimbingRoute} from '../../../models/ClimbigRoute';
import {ClimbingEvent, getDifficultyFor} from "../../../models/ClimbingEvent";
import {EventInfoComponent} from "./EventInfoComponent";
import {ViewEventResultsComponent} from "./ViewEventResultsComponent";
import {AddCompetitionPoints} from "./AddCompetitionPoints";

type Props = {
    event: ClimbingEvent
    updateRoute: (route: ClimbingRoute) => void,
    refreshEvent: () => void
}

type AnchorAndId = {
    anchor: HTMLElement,
    id: number
}
export const EditEventComponent: React.FC<Props> = ({event, updateRoute, refreshEvent}) => {

    const dificulties = getDifficultyFor(event.type, event.showGrade);
    const [anchorAndId, setAnchorAndId] = useState<null | AnchorAndId>(null);
    const [isEditing, setEditing] = useState(true);
    const [isJudge, setJudge ] = useState(false);

    const handleEditChange = () => {
        setEditing(!isEditing)
        setJudge(false)
    }

    const handleJudgeChange = () => {
        setJudge(!isJudge)
        setEditing(false)
    }

    const handleMenu = (htmlEvent: React.MouseEvent<HTMLElement>, routeId?: number) => {
        setAnchorAndId({
            anchor: htmlEvent.currentTarget,
            id: routeId || event.routes.length + 1
        });
    };

    const handleClose = () => {
        setAnchorAndId(null);
    };

    const updateOrCreateRoute = (dificulty: string) => {
        if (anchorAndId) {
            var climbingRoute = new ClimbingRoute(anchorAndId?.id, dificulty);
            updateRoute(climbingRoute);
            setAnchorAndId(null);
        } else {
            console.error("no anchor");
        }

    }

    return (
        <Box width="80%">
            <Menu
                id="menu-appbar"
                anchorEl={anchorAndId?.anchor}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorAndId)}
                onClose={handleClose}
            >
                {dificulties.map(d => <MenuItem key={"dificulty-" + d.difficulty}
                                                sx={{backgroundColor: d.colour ? d.colour : "white"}}
                                                onClick={() => updateOrCreateRoute(d.difficulty)}>{d.difficulty}</MenuItem>)}
            </Menu>
            <EventInfoComponent event={event} refreshEvent={refreshEvent}/>
            <Box justifyContent="center" display="flex" mb={1}>
                <Button variant="outlined" onClick={handleEditChange}>{isEditing ? "Wyniki" : "edycja"}</Button>
                <Button variant="outlined" onClick={handleJudgeChange}>Sędzia</Button>
            </Box>

            {isJudge &&
                <AddCompetitionPoints event={event}/>}
            {!isJudge && isEditing &&
                <RoutesGrid dificulties={dificulties} routes={event.routes} handleMenu={handleMenu}
                            addNewRouteButton={true}/>
            }
            {!isJudge && !isEditing &&
                <ViewEventResultsComponent event={event}/>
            }

        </Box>)
}
